import { Column } from '@antv/g2plot';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { data } from './hardcoded';
import { renderTooltip } from '../../../../helpers/Tooltip';
import moment from 'moment';

export default function useMercuryUseMonthlyTracking({ container }) {
  const [mainGraph, setMainGraph] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (container.current) {
      const customContent = (title, data) => {
        if (Array.isArray(data) && data[0]) {
          return renderTooltip({
            title: moment(Number((title || '').split('M')[1]), 'M').format('MMMM'),
            items: [
              {
                label: t('Total Mercury Used'),
                color: data[0].color,
                value: data[0].data?.value || 0,
              },
              {
                label: t('Total Gold Produced'),
                color: data[1].color,
                value: data[1].data?.value || 0,
              },
            ]
          });
        }

        return '';
      };

      if (mainGraph) {
        mainGraph.update({
          data: data,
          tooltip: { customContent },
          yAxis: {
            tickMethod: data.length ? (a) => [1, 2, 3, 4, 5] : undefined,
          },
        });
      } else {
        const area = new Column(container.current, {
          height: 354,
          data: data,
          xField: 'time',
          localRefresh: true,
          animation: false,
          yField: 'value',
          seriesField: 'type',
          point: {
            shape: 'round',
            size: 3,
          },
          yAxis: {
            tickMethod: data.length ? (a) => [1, 2, 3, 4, 5] : undefined,
          },
          isGroup: true,
          xAxis: {
            nice: true,
          },
          legend: false,
          tooltip: {
            shared: true,
            customContent,
          },
        });
        area.render();
        setMainGraph(area);
      }
    }
  }, [container, t]);
}
